import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Grid, GridSearchItem, ServiceSearchItem} from '../../../../shared/Models/grid';
import {CreditInvoiceService} from '../../../Services/creditInvoice.service';
import {ActionColumn, ActionItem, BooleanColumn, TextColumn} from '../../../../shared/Models/columns';
import * as moment from 'moment';
import {AuthenticationService} from '../../../../shared/Services/authentication.service';
import {NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import {NgbCountryDateParserFormatter} from '../../../../shared/Services/NgbCountryDateParserFormatter';
import {Router} from '@angular/router';

@Component({
  selector: 'app-credit-invoice-overview',
  templateUrl: './credit-invoice-overview.component.html',
  styleUrls: ['./credit-invoice-overview.component.scss'],
  providers: [
    {provide: NgbDateParserFormatter, useClass: NgbCountryDateParserFormatter}
  ],
})
export class CreditInvoiceOverviewComponent implements OnInit {
  public grid: Grid;

  @ViewChild('customerPriceTemp', {static: false}) customerPriceTemp;
  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;

  constructor(private router: Router, private creditInvoiceService: CreditInvoiceService, private auth: AuthenticationService) {
  }

  ngOnInit() {
    const dateFormat = this.auth.getDateFormat();
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.backoffice.credit-invoice.date',
          prop: 'created',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          width: 50,
          valueFormatter: row => moment(row).format(dateFormat),
        },
        <TextColumn>{
          name: 'doctrine.backoffice.credit-invoice.number',
          prop: 'id',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          width: 50,
        },
        <TextColumn>{
          name: 'doctrine.backoffice.credit-invoice.dealer_number',
          prop: 'invoiceDealer.id',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          width: 100,
          valueFormatter: row => new Array(4 - (row + '').length).join('0') + row,
        },
        <TextColumn>{
          name: 'doctrine.backoffice.credit-invoice.dealer',
          prop: 'invoiceDealer.companyName',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          width: 100,
        },
        <TextColumn>{
          name: 'doctrine.backoffice.credit-invoice.amount',
          prop: 'amount',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          width: 50,
          valueTemplate: this.customerPriceTemp,
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-download fa-lg',
              tooltip: 'global.download',
              onclick: (row) => {
                this.creditInvoiceService.getPdf(row.id).subscribe((resp: {url: string, filename: string}) => {
                  const el: HTMLElement = this.downloadLink.nativeElement as HTMLElement;
                  el.setAttribute('href', resp.url);
                  el.setAttribute('download', resp.filename);
                  el.click();
                });
              },
              showCallback: row => row,
              btnClass: 'ripple light'
            },
          ]
        },
      ],
      service: this.creditInvoiceService,
      rememberURL: this.router.url,
      method: 'getCreditInvoices',
      defaultSort: 'id',
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true,
      doseNotHaveSearch: true,
      search: [
        <GridSearchItem>{
          calendarFromDate: 'from',
          calendarToDate: 'to',
          hasCalendar: true,
          label: 'doctrine.attributes.model',
          hasDropdownListFilter: false,
          hasNormalSearch: true,
        }
      ],
    };
  }

}
